module.exports = __webpack_public_path__ + "img/record.f94101b6.jpg";